/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface ChartProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Chart: React.FC<ChartProps> = ({ color = '#222A34', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.3334 11.0446V7.71131C18.3334 3.54464 16.6667 1.87798 12.5001 1.87798H7.50008C3.33341 1.87798 1.66675 3.54464 1.66675 7.71131V12.7113C1.66675 16.878 3.33341 18.5446 7.50008 18.5446H10.8334"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.10669 12.2861L8.09003 9.71111C8.37336 9.34444 8.89836 9.27778 9.26503 9.56111L10.79 10.7611C11.1567 11.0444 11.6817 10.9778 11.965 10.6195L13.89 8.13611"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2366 13.3945L16.4699 13.8695C16.5866 14.1029 16.8783 14.3195 17.1366 14.3695L17.4533 14.4195C18.4033 14.5779 18.6283 15.2779 17.9449 15.9695L17.6533 16.2612C17.4616 16.4612 17.3533 16.8445 17.4116 17.1112L17.4533 17.2862C17.7116 18.4362 17.1033 18.8779 16.1033 18.2779L15.8866 18.1529C15.6283 18.0029 15.2116 18.0029 14.9533 18.1529L14.7366 18.2779C13.7283 18.8862 13.1199 18.4362 13.3866 17.2862L13.4283 17.1112C13.4866 16.8445 13.3783 16.4612 13.1866 16.2612L12.8949 15.9695C12.2116 15.2779 12.4366 14.5779 13.3866 14.4195L13.7033 14.3695C13.9533 14.3279 14.2533 14.1029 14.3699 13.8695L14.6033 13.3945C15.0533 12.4862 15.7866 12.4862 16.2366 13.3945Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
